import React, { useState } from "react";
import SocialIcons from "../../cards/SocialIcons";
import logo from "../../../assets/img/logo3.jpg";
import "./Header.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

export default function Header() {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;

    navigate(`/search/${encodeURIComponent(query)}`);
  };

  return (
    <header className="site-header border-bottom py-2" style={{ background: "#EEE" }}>
      <div className="container d-flex justify-content-between align-items-center flex-wrap">
        <div className="logo-wrapper mb-2 mb-md-0">
          <Link to="/">
            <img className="loay" src={logo} alt="logo" style={{ width: 260, height: 120 }} />
          </Link>
        </div>

        <div className="me-auto d-flex flex-column align-items-end ms-5">
          <div className="ms-4 d-none d-md-block">
            <SocialIcons />
          </div>

          <form className="position-relative d-none d-md-block" style={{ width: 280 }} onSubmit={handleSearch}>
            <input
              type="search"
              className="form-control rounded-pill ps-4"
              placeholder="ابحث في الموقع..."
              dir="rtl"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button
              type="submit"
              className="btn position-absolute top-0 bottom-0 start-0 px-3 border-0 bg-transparent ms-4"
            >
              <i className="fas fa-search" />
            </button>
          </form>
        </div>
      </div>
    </header>
  );
}
